import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence, useReducedMotion } from 'framer-motion';
import { pricing } from '../data/offer';
import { CtaButton } from './CtaButton';
export function StickyBar() {
  const [visible, setVisible] = useState(false);
  const reduceMotion = useReducedMotion();
  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 700);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <AnimatePresence data-id="element-288" data-mp="jtps8nrbpwld">
      {visible && <motion.div initial={{
      y: reduceMotion ? 0 : 64,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: reduceMotion ? 0 : 64,
      opacity: 0
    }} transition={{
      duration: 0.22,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 border-t border-forest-700 bg-forest-900/97 backdrop-blur" data-id="element-289" data-mp="evegu8ldre11">
          <div className="mx-auto flex max-w-content items-center justify-between gap-3 px-4 py-2.5 sm:gap-5 sm:px-8 sm:py-3" data-id="element-290" data-mp="2491h0217y3fr">
            <div className="min-w-0" data-id="element-291" data-mp="3mh3pl9f7vtba">
              <p className="truncate font-display text-[13px] font-bold uppercase tracking-wide text-cream-50 sm:text-sm" data-id="element-292" data-mp="3mi5dwfl8ucay">
                MegaPack + 5 bonos
              </p>
              <p className="text-[13px] text-moss-200 sm:text-sm" data-id="element-293" data-mp="3dgythvfh4hcf">
                <span className="line-through" data-id="element-294" data-mp="50449irlmvgt">{pricing.regular}</span>{' '}
                <span className="font-semibold text-cream-50" data-id="element-295" data-mp="526ykezsbarc">{pricing.today}</span>
              </p>
            </div>
            <CtaButton size="md" variant="inverse" className="!w-auto !px-5 !py-2.5 !text-[13px] sm:!px-6 sm:!py-3 sm:!text-sm" data-id="element-296" data-mp="3rfopf7qk4az7">
              Comprar
            </CtaButton>
          </div>
        </motion.div>}
    </AnimatePresence>;
}